import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from '../../styles/ThankyouLYWelcomeTexts.module.css';
import { CLOUDFRONT_LANDING_PAGE_ROOT_URL } from '@shared/config/constants/app';
import { useAtomValue } from 'jotai';

import { languageAtom } from '@shared/store/slice-atoms';
import { isRTL } from '@shared/utils/general';

const welcomeImg = `${CLOUDFRONT_LANDING_PAGE_ROOT_URL}/icons/welcome-img.webp`;

export const ThankyouLIWelcomeTexts = () => {
  const { t } = useTranslation();

  const language = useAtomValue(languageAtom);

  const isRTLDirection = isRTL(language.direction);

  const handleOpenLYLink = () => {
    window.open('https://meaapp.app.link', '_blank', 'noopener noreferrer');
  };

  return (
    <div>
      <div className="text-center">
        <img src={welcomeImg} className="img-fluid welcome-img" alt="" />
      </div>

      <div className="text-center">
        <p className="welcome-text-1">{t('welcome_ly_1')}</p>
      </div>

      <div className="text-center">
        <p className="welcome-text-1">{t('welcome_ly_1_n')}</p>
      </div>

      <div>
        <p className="welcome-text-2" style={{ textAlign: isRTLDirection ? 'right' : 'left' }}>
          {t('welcome_ly_2')}
        </p>
      </div>

      <div
        className="text-center"
        style={{ marginBottom: '24px', cursor: 'pointer' }}
        onClick={handleOpenLYLink}
      >
        <p className={styles['welcome-text-1-ly']}>{t('download_ly_3')}</p>
      </div>

      <div>
        <p style={{ textAlign: isRTLDirection ? 'right' : 'left' }} className="welcome-text-2">
          {t('welcome_ly_3')}
        </p>

        <p style={{ textAlign: isRTLDirection ? 'right' : 'left' }} className="welcome-text-2">
          support@360mea.com
        </p>
      </div>
    </div>
  );
};
